var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "user-cell",
      on: {
        mouseenter: function ($event) {
          _vm.showMenu = true
        },
        mouseleave: _vm.hideMenu,
      },
    },
    [
      _vm.user
        ? _c(
            "div",
            { staticClass: "user-info" },
            [
              _c("AgentAvatar", { attrs: { userID: _vm.user._id, size: 32 } }),
              _vm._v(" "),
              _c("span", { staticClass: "user-name" }, [
                _vm._v(_vm._s(_vm.user.name)),
              ]),
            ],
            1
          )
        : _c(
            "PermissionController",
            { attrs: { permissions: ["table.update"] } },
            [
              _c("a", { on: { click: _vm.showUserPicker } }, [
                _vm._v(_vm._s(_vm.$t("table.addUser"))),
              ]),
            ]
          ),
      _vm._v(" "),
      _vm.showMenu && _vm.user && !_vm.readonly
        ? _c(
            "div",
            {
              staticClass: "user-menu",
              on: { mouseenter: _vm.cancelHide, mouseleave: _vm.hideMenu },
            },
            [
              _c(
                "PermissionController",
                { attrs: { permissions: ["table.update"] } },
                [
                  _c("SupsisButton", {
                    attrs: { icon: "edit", xxsmall: "" },
                    on: { click: _vm.editUser },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "PermissionController",
                { attrs: { permissions: ["table.update"] } },
                [
                  _c("SupsisButton", {
                    attrs: { icon: "delete", xxsmall: "" },
                    on: { click: _vm.removeUser },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Kullanıcı Seç",
                okText: "Kaydet",
                xlarge: "",
                className: "user-picker-modal  keydown-prevent-modal",
              },
              on: { cancel: _vm.closeModal },
            },
            [_c("UserPicker", { on: { "user-selected": _vm.onUserSelected } })],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }